import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Box,
    IconButton,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import nameLogo from '../assets/name_logo.png';
import nameLogoBlack from '../assets/name_logo-black.png';
import searchLogo from '../assets/search_logo.png';
import signInLogo from '../assets/sign_in_logo.png';
import heartLogo from '../assets/heart_logo.png';

const Navbar = () => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    return (
        <AppBar 
            position="fixed" 
            sx={{ 
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'transparent',
                boxShadow: 'none',
                backdropFilter: 'none',
            }}
        >
            <Toolbar>
                {/* Logo in top left */}
                <Box
                    component={Link}
                    to="/"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        flexGrow: 1,
                    }}
                >
                    <img 
                        src={isHomePage ? nameLogo : nameLogoBlack} 
                        alt="rinovo" 
                        style={{ 
                            height: '40px',
                            maxWidth: '200px',
                            objectFit: 'contain'
                        }} 
                    />
                </Box>
                {/* Search and Sign In icons in top right */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
                        onClick={() => {
                            if (isAuthenticated) {
                                navigate('/saved');
                            } else {
                                navigate('/login');
                            }
                        }}
                        sx={{
                            p: 0,
                            '&:hover': { opacity: 0.8 }
                        }}
                    >
                        <img 
                            src={heartLogo} 
                            alt="Saved" 
                            style={{ 
                                height: '32px',
                                width: '32px',
                                objectFit: 'contain'
                            }} 
                        />
                    </IconButton>
                    <IconButton
                        component={Link}
                        to="/search"
                        sx={{
                            p: 0,
                            '&:hover': { opacity: 0.8 }
                        }}
                    >
                        <img 
                            src={searchLogo} 
                            alt="Search" 
                            style={{ 
                                height: '32px',
                                width: '32px',
                                objectFit: 'contain'
                            }} 
                        />
                    </IconButton>
                    <IconButton
                        component={Link}
                        to="/login"
                        sx={{
                            p: 0,
                            '&:hover': { opacity: 0.8 }
                        }}
                    >
                        <img 
                            src={signInLogo} 
                            alt="Sign In" 
                            style={{ 
                                height: '32px',
                                width: '32px',
                                objectFit: 'contain'
                            }} 
                        />
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar; 